/**
 * ZAXIA Staff useAuth Hook
 * Provides access to authentication context
 *
 * Phase P2.1-3: Global Auth Context & Session Management
 *
 * Usage:
 *   const { user, isAuthenticated, login, logout } = useAuth();
 *
 * IMPORTANT: After this phase, no component should access localStorage directly.
 * All auth state must be accessed through this hook.
 */

import { useContext } from 'react';
import { AuthContext, AuthContextValue } from '../context/AuthContext';

/**
 * Hook to access authentication context
 *
 * @throws Error if used outside of AuthProvider
 * @returns AuthContextValue with user, token, auth state, and auth methods
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);

  if (context === null) {
    throw new Error(
      'useAuth must be used within an AuthProvider. ' +
        'Make sure your component is wrapped in <AuthProvider>.'
    );
  }

  return context;
}
